import { useReactiveVar } from '@apollo/client';
import { initData, useSignal } from '@tma.js/sdk-react';
import { useEffect } from 'react';
import { loginData } from '../client/apollo';

type UserIdTrackerProps = {
    setUserId: (userId: string) => void;
};

export function UserIdTracker({ setUserId }: UserIdTrackerProps) {
    const authData = useReactiveVar(loginData);
    const tgUser = useSignal(initData.user);
    const telegramUserId = tgUser?.id != null ? String(tgUser.id) : null;

    useEffect(() => {
        if (telegramUserId) {
            setUserId(telegramUserId);
            return;
        }
        if (authData?.userId) {
            setUserId(authData.userId);
        }
    }, [authData?.userId, setUserId, telegramUserId]);

    return null;
}
